<template>
  <ValidationProvider v-bind="$props">
    <template #default="slotProps">
      <slot v-bind="slotProps" />
    </template>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { registerEventListener } from '../event-bus/event-bus';

export default {
  name: 'RegisteredField',
  inject: ['formFields'],
  components: {
    ValidationProvider
  },
  props: {
    ...ValidationProvider.options.props,
    isFocusable: { type: Boolean, default: false }
  },
  methods: {
    registerField() {
      const vid = this.$props.vid;
      if (vid)
        this.formFields[vid] = {
          name: this.$props.label || this.$attrs.label, //TODO check this
          isFocusable: this.isFocusable
        };
    }
  },
  mixins: [
    registerEventListener('focus', 'focusInput', function (value) {
      if (this.$props.vid === value) this.$slots.default[0]?.focus();
    })
  ],
  mounted() {
    this.registerField();
  }
};
</script>
